'use client';
import React from 'react';
import { Search } from 'lucide-react';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

export default function SearchBar({ placeholder = 'Search...', value, onChange }: SearchBarProps) {
  return (
    <div className="relative">
      <Search
        size={16}
        className="absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none"
        style={{ color: '#A7A3C4' }}
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-10 pr-4 py-2.5 text-[14px] rounded-lg transition-all duration-150 focus:outline-none"
        style={{
          background: '#0F0D1D',
          border: '1px solid rgba(255,255,255,0.10)',
          color: '#F2F4FF',
        }}
        onFocus={(e) => {
          e.currentTarget.style.borderColor = 'rgba(76,201,255,0.40)';
          e.currentTarget.style.boxShadow = '0 0 0 3px rgba(76,201,255,0.08)';
        }}
        onBlur={(e) => {
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.10)';
          e.currentTarget.style.boxShadow = 'none';
        }}
      />
    </div>
  );
}
